import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

/**
 * ag-grid 커뮤니티 모듈 일괄 등록 (앱 진입 시 1회)
 * - Community 라이센스 범위 내 모든 기능만 등록 (정렬/필터/페이지네이션/리사이즈/CSV export 등)
 * - Enterprise 모듈은 등록하지 않음 (row grouping, pivot, set filter, master-detail 등)
 */
let registered = false;

export function registerAgGridModules() {
  if (registered) return;
  ModuleRegistry.registerModules([AllCommunityModule]);
  registered = true;
}
